/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_FUNCTIONAL_UNITS_RESPONSE = [
	{ name: "500 API Calls" },
	{ name: "1000 API Calls" },
	{ name: "Single Transaction" },
	{ name: "Batch Job" },
	{ name: "Monthly Report" },
	{ name: "Monthly Report1" },
	{ name: "Monthly Report2" },
	{ name: "Monthly Report3" },
	{ name: "Monthly Report4" },
	{ name: "Monthly Report5" },
	{ name: "Monthly Report6" },
	{ name: "Monthly Report7" },
	{ name: "Monthly Report8" },
	{ name: "Monthly Report9" },
	{ name: "Monthly Report10" },
	{ name: "Monthly Report11" },
	{ name: "Monthly Report12" },
	{ name: "Monthly Report13" },
	{ name: "Monthly Report14" },
	{ name: "Monthly Report15" },
	{ name: "Monthly Report16" },
	{ name: "Monthly Report17" },
	{ name: "Monthly Report18" },
	{ name: "Monthly Report19" }
];

export const GET_ROLES_RESPONSE = [
	{
		code: "VIEWER",
		description: ""
	},
	{
		code: "USER",
		description: ""
	},
	{
		code: "ADMIN",
		description: ""
	}
];

export const GET_USER_INFO_RESPONSE = {
	id: 10,
	name: "Carlo",
	surname: "Rossi",
	username: "Carlo_Rossi",
	email: "Carlo_Rossi@gmail.com",
	description: "",
	snEnabled: true,
	dcEnabled: true,
	applications: [
		{
			name: "GCP Application",
			layers: [
				"Compute Engine Machine Learning",
				"Cloud Function",
				"GKE Cluster",
				"Cloud Sql Postgres"
			],
			functionalUnit: "API Calls"
		}
	],

	role: "ADMIN",
	grants: [
		"impact:tab",
		"swabl:tab",
		"swabl:widget:totalApplications",
		"swart:tab",
		"swart:widget:totalCo2Emissions",
		"cloud:tab",
		"hwabl:tab",
		"hwart:tab",
		"dc:tab",
		"dc:widget:overview",
		"dc:widget:summary",
		"dc:widget:efficiencyMetrics",
		"dc:widget:keyMetrics",
		"dc:widget:energyConsumptionAndEmissions",
		"dc:widget:energyBreakdown",
		"ai:tab",
		"toolbox:tab",
		"re:tab"
	],
	tenants: [
		{
			tenantId: "tenant01",
			name: "Carlo Rossi",
			desc: ""
		}
	]
};

export const GET_USERS_RESPONSE = [
	{
		first: true,
		last: true,
		size: 10,
		totalElements: 2,
		totalPages: 1,
		number: 0,
		contents: [
			{
				id: 1,
				name: "Carlo",
				surname: "Rossi",
				username: "Carlo_Rossi",
				email: "Carlo_Rossi@gmail.com",
				description: "",
				dcEnabled: true,
				applications: [
					{
						name: "GCP Application",
						layers: [
							"Compute Engine Machine Learning",
							"Cloud Function",
							"GKE Cluster",
							"Cloud Sql Postgres"
						],
						functionalUnit: "API Calls"
					}
				],
				role: "ADMIN",
				tenants: [
					{
						tenantId: "tenant01",
						name: "Carlo Rossi",
						desc: ""
					}
				]
			},
			{
				id: 2,
				name: "Carlo",
				surname: "Rossi",
				username: "Carlo_Rossi",
				email: "Carlo_Rossi@gmail.com",
				description: "",
				dcEnabled: true,
				applications: [
					{
						name: "GCP Application",
						layers: [
							"Compute Engine Machine Learning",
							"Cloud Function",
							"GKE Cluster",
							"Cloud Sql Postgres"
						],
						functionalUnit: "API Calls"
					}
				],
				role: "ADMIN",
				tenants: [
					{
						tenantId: "tenant01",
						name: "Carlo Rossi",
						desc: ""
					}
				]
			}
		]
	}
];

export const GET_USER_RESPONSE = {
	id: 10,
	mailNotification: false,
	pushNotification: false,
	name: "Carlo",
	surname: "Rossi",
	username: "Carlo_Rossi",
	email: "Carlo_Rossi@gmail.com",
	description: "",
	dcEnabled: true,
	applications: [
		{
			name: "GCP Application",
			layers: [
				"Compute Engine Machine Learning",
				"Cloud Function",
				"GKE Cluster",
				"Cloud Sql Postgres"
			],
			functionalUnit: "API Calls"
		}
	],
	role: "ADMIN",
	tenants: [
		{
			tenantId: "tenant01",
			name: "Carlo Rossi",
			desc: ""
		}
	]
};
